import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';

interface PromotionFeaturesProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromotionFeatures: React.FC<PromotionFeaturesProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <>
      <FormField label="Espaces extérieurs">
        <div className="grid grid-cols-2 gap-4">
          {[
            { name: 'hasGardens', dbName: 'gardens', label: 'Jardins' },
            { name: 'hasTerraces', dbName: 'terraces', label: 'Terrasses' },
            { name: 'hasCourtyard', dbName: 'courtyards', label: 'Cours' },
            { name: 'hasGreenSpaces', dbName: 'green_spaces', label: 'Espaces verts' },
            { name: 'hasRooftop', dbName: 'rooftops', label: 'Rooftops' },
          ].map(({ name, dbName, label }) => (
            <label key={name} className="flex items-center gap-2">
              <input
                type="checkbox"
                name={name}
                checked={property?.[dbName] ?? formData[name] ?? false}
                onChange={handleInputChange}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </FormField>

      <FormField label="Parkings et garages">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
              Nombre total d'emplacements
            </label>
            <input
              type="number"
              name="parkingSpaces"
              value={property?.total_parking_spaces ?? formData.parkingSpaces ?? ''}
              onChange={handleInputChange}
              min="0"
              className="mt-1"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { name: 'hasIndoorParking', dbName: 'indoor_parking', label: 'Parkings intérieurs' },
              { name: 'hasOutdoorParking', dbName: 'outdoor_parking', label: 'Parkings extérieurs' },
              { name: 'hasUndergroundParking', dbName: 'underground_parking', label: 'Parkings sous-terrains' },
            ].map(({ name, dbName, label }) => (
              <label key={name} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name={name}
                  checked={property?.[dbName] ?? formData[name] ?? false}
                  onChange={handleInputChange}
                />
                <span>{label}</span>
              </label>
            ))}
          </div>
        </div>
      </FormField>

      <FormRow>
        <FormField label="Ascenseur">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasElevator"
              checked={property?.has_elevator ?? formData.hasElevator ?? false}
              onChange={handleInputChange}
            />
            <span>Oui</span>
          </label>
        </FormField>

        <FormField label="Climatisation">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasAirConditioning"
              checked={property?.has_air_conditioning ?? formData.hasAirConditioning ?? false}
              onChange={handleInputChange}
            />
            <span>Oui</span>
          </label>
        </FormField>
      </FormRow>
    </>
  );
};